import { _js } from '@ifixit/localize';

const ModerationPage = {
   voteFilter: 'all',
   selected: null,
   shortcutsEnabled: true,
   UP_VOTE: 1,
   DOWN_VOTE: -1,
   toggleContext: function (el) {
      let entry = el.getParent('.vote-entry');
      let contextArea = entry.getFirst('.context-area');
      let detailsIcon = el.getFirst('.details-icon');
      let link = el.getFirst('.vote-details');

      let expandText = _js('Show details');
      let collapseText = _js('Hide details');

      if (entry.hasClass('context-shown')) {
         detailsIcon.set('html', '+');
         detailsIcon.removeClass('hide-icon');
         link.set('text', expandText);
         entry.removeClass('context-shown');
         contextArea.addClass('hidden');
      } else {
         detailsIcon.set('html', '&ndash;');
         detailsIcon.addClass('hide-icon');
         link.set('text', collapseText);
         entry.addClass('context-shown');
         contextArea.removeClass('hidden');
      }
   },

   setupContextLinks: function () {
      $$('.vote-entry').each(entry => {
         entry.getElements('.details-container').each(container => {
            container.addEvent('click', function (ev) {
               ev.stop();
               ModerationPage.toggleContext(this);
            });
         });
      });
   },

   select: function (entry) {
      if (this.selected) {
         this.selected.removeClass('selected');
      }
      entry.addClass('selected');
      entry.scrollIntoView({
         behavior: 'smooth',
         block: 'center',
      });
      this.selected = entry;
   },

   openKeyboardModal: function () {
      void import('Shared/modal').then(({ Modal }) => {
         Modal.open({
            type: 'element',
            element: $('shortcuts-modal'),
         });
      });
   },

   hasSelected: function () {
      return ModerationPage.selected;
   },

   setupKeyboardShortcuts: function () {
      window.addEvents({
         'keydown:keys(shift+/)': function (ev) {
            ModerationPage.keyAction('openModal', ev);
         },
         'keydown:keys(s)': function (ev) {
            ModerationPage.keyAction('moveDown', ev);
         },
         'keydown:keys(down)': function (ev) {
            ModerationPage.keyAction('moveDown', ev);
         },
         'keydown:keys(w)': function (ev) {
            ModerationPage.keyAction('moveUp', ev);
         },
         'keydown:keys(up)': function (ev) {
            ModerationPage.keyAction('moveUp', ev);
         },
         'keydown:keys(e)': function (ev) {
            ModerationPage.keyAction('expand', ev);
         },
         'keydown:keys(p)': function (ev) {
            ModerationPage.keyAction('passVote', ev);
         },
         'keydown:keys(f)': function (ev) {
            ModerationPage.keyAction('failVote', ev);
         },
      });
   },

   keyAction: function (action, ev) {
      if ($$('.modalOpen').length || !ModerationPage.shortcutsEnabled) {
         return;
      }

      let selected = ModerationPage.selected;
      ev.stop();

      if (action == 'openModal') {
         ModerationPage.openKeyboardModal();
      }

      if (!selected && !(ev.meta || ev.control || ev.shift)) {
         let entries = $$('.vote-entry').filter(entry => !entry.hasClass('voted'));

         if (entries.length > 0) {
            ModerationPage.select(entries[0]);
         }
      } else if (selected) {
         let voteid = selected.get('data-id');
         let next = selected.getNext('.vote-entry');

         if (action == 'moveDown') {
            if (next) {
               ModerationPage.select(next);
            }
         } else if (action == 'moveUp') {
            let prev = selected.getPrevious('.vote-entry');
            if (prev) {
               ModerationPage.select(prev);
            }
         } else if (action == 'expand') {
            let detailsDiv = selected.getFirst('.details-container');
            ModerationPage.toggleContext(detailsDiv);
         } else if (action == 'passVote') {
            if (selected.hasClass('pending')) {
               ModerationPage.vote(selected, voteid, ModerationPage.UP_VOTE);

               if (next) {
                  ModerationPage.select(next);
               }
            }
         } else if (action == 'failVote' && selected.hasClass('pending')) {
            ModerationPage.vote(selected, voteid, ModerationPage.DOWN_VOTE);
            if (next) {
               ModerationPage.select(next);
            }
         }
      }
   },

   setupVoteButtons: function () {
      $$('.pass-fail-buttons').each(buttons => {
         let voteid = buttons.getParent('.vote-entry').get('data-id');
         if (buttons.get('data-user-vote') == ModerationPage.UP_VOTE) {
            buttons.getFirst('.js-pass-vote').addEvent('click', ev => {
               ev.stop();
               ModerationPage.resetVoteModal(voteid);
            });
         } else if (buttons.get('data-user-vote') == ModerationPage.DOWN_VOTE) {
            buttons.getFirst('.js-fail-vote').addEvent('click', ev => {
               ev.stop();
               ModerationPage.resetVoteModal(voteid);
            });
         } else {
            let passButton = buttons.getFirst('.js-pass-vote');
            if (passButton) {
               passButton.addEvent('click', ev => {
                  ev.stop();
                  ModerationPage.vote(passButton, voteid, ModerationPage.UP_VOTE);
               });
            }

            let failButton = buttons.getFirst('.js-fail-vote');
            if (failButton) {
               failButton.addEvent('click', ev => {
                  ev.stop();
                  ModerationPage.vote(failButton, voteid, ModerationPage.DOWN_VOTE);
               });
            }
         }
      });
   },

   refreshContent: function (voteStatus) {
      let filter = ModerationPage.voteFilter;
      new Request.AjaxIO('refreshVotes', {
         onSuccess: function (data) {
            if (data.error != null) {
               return alert(data.error);
            }

            $('moderation').set('html', data.html);
            ModerationPage.setupContextLinks();
            ModerationPage.setupVoteButtons();

            if (ModerationPage.selected) {
               $$('.vote-entry').each(entry => {
                  if (entry.get('data-id') == ModerationPage.selected.get('data-id')) {
                     ModerationPage.select(entry);
                  }
               });
            }
         },
      }).send(voteStatus, filter);
   },

   vote: function (button, voteid, score) {
      const toggle = document.querySelector('#superPowersToggle');
      const adminForced = toggle && toggle.checked;
      button.addClass('vote-button-disabled');

      let voteRequest = new Request.AjaxIO('vote', {
         onSuccess: function (result) {
            ModerationPage.refreshContent('pending');
            button.removeClass('vote-button-disabled');
         },
         onError: function (result) {
            button.removeClass('vote-button-disabled');
         },
      }).send(voteid, score, adminForced);

      LoadingIndicator.withPromise(voteRequest, {
         pendingMessage: _js('Processing'),
         successMessage: _js('Vote Recorded'),
         failureMessage: _js('Error Recording Vote'),
      });
   },

   resetVoteModal: function (voteid) {
      void import('Shared/modal').then(({ Modal }) => {
         let modal = $('reset-modal');
         let confirm = $$('#reset-modal .reset-confirm');
         confirm.removeEvents();
         confirm.addEvent('click', ev => {
            Modal.close();
            ModerationPage.cancelVote(voteid);
         });

         Modal.open({
            type: 'element',
            element: modal,
         });
      });
   },

   cancelVote: function (voteid) {
      new Request.AjaxIO('cancelVote', {
         onSuccess: function (result) {
            ModerationPage.refreshContent('pending');
         },
      }).send(voteid);
   },
};

onDomReady(() => {
   ModerationPage.setupContextLinks();
   ModerationPage.setupKeyboardShortcuts();
   ModerationPage.setupVoteButtons();

   let allInputs = $(document.body).getElements('input');
   allInputs.each(input => {
      input.addEvent('focus', () => {
         ModerationPage.shortcutsEnabled = false;
      });

      input.addEvent('blur', () => {
         ModerationPage.shortcutsEnabled = true;
      });
   });

   $$('#vote-filters a').each(link => {
      link.addEvent('click', ev => {
         ev.stop();
         ModerationPage.voteFilter = link.get('data-voteFilter');
         $$('#vote-filters a').removeClass('filter-option-active');
         link.addClass('filter-option-active');
         ModerationPage.refreshContent('pending');
      });

      link.addEvent('mouseenter', ev => {
         link.addClass('activeButton');
      });

      link.addEvent('mouseleave', ev => {
         link.removeClass('activeButton');
      });
   });

   $$('.js-toggle-selected').addEvent('click', function () {
      let target = this.getParent().getElement('.js-toggle-target');
      target.toggleClass('toggle-open');
   });

   $('content').addEvents({
      'click:relay(.js-toggle-target)': function (ev, el) {
         $$('.js-toggle-target').removeClass('toggle-open');
         $$('.js-toggle-selected').removeClass('selected');
      },
   });

   if (App.totalVotes === 1) {
      $$('.vote-details')[0].click();
   }
});
